module.exports = __webpack_public_path__ + "img/90398cc.svg";